import { QuestionType } from "./QuestionType"

export class QuestionnaireQuestion {
    questionId?: number // auto-generated identifier
    questionNumber?: string // custom identifier
    questionType?: QuestionType

    titleEn?: string
    titleFr?: string
    titleNl?: string
    titleDe?: string
    displayedTitle: string

    // specific to QuestionType.Checkbox
    checkboxValue?: boolean
    checkboxLabelEn?: string
    checkboxLabelFr?: string
    checkboxLabelNl?: string
    checkboxLabelDe?: string

    // specific to QuestionType.Range
    rangeValue?: number

    rangeLabelsEn?: string[]
    rangeLabelsFr?: string[]
    rangeLabelsNl?: string[]
    rangeLabelsDe?: string[]
    displayedRangeLabels?: string[]

    // specific to QuestionType.Radio
    radioValue?: number
    radioValues?: number[]
    radioLabelsEn?: string[]
    radioLabelsFr?: string[]
    radioLabelsNl?: string[]
    radioLabelsDe?: string[]
    displayedRadioLabels?: string[]

    // specific to QuestionType.Text
    textValue?: string
    textDefaultValue?: string
    textFormat?: string
    textFormatRegex?: string
    placeholderValueEn?: string
    placeholderValueFr?: string
    placeholderValueNl?: string
    placeholderValueDe?: string

    //Comstetic display
    lastOfSubsection?: boolean
}
